import { isCanlan } from './customer-name'

/* Felipe Nunes: Updated Sat, 06 Dec 2025 3:27 AM ( CET ) */
// If it fails (like if the previously set hardcoded token is expired)
// try setting the hardcoded token again (hopefully a new one)
// {
//   "access_token": "v2.local.8sEn6tliWKBreIJ_TwNhoTu43fNGNSO1r04oR3HaDD3H7NWRMzWMIz9fLcobWk8gQVGE5KK-Fwz3wQd_e_NHgq-rabwepC5jGYV4YvXMvR80Lq8nsBOd0j7GwjChVOla6wmdwp-gVJ0t77oGJdtGEd8j-Mx7gHODVmnSBFOCPTs89aacnzBKuD5BAHMYLjmRdtz4PJJgyFqlzu7qaq_vmSFdH_vZRj81-vYaRInZVqrn5Bi0zx7xELVa9Nh-1dx6UMSyjh2rR36Wg6-MBYfXwXGhIxFSD4KgpWutq4tbct2gJ8u8YBCSxU9PtzdtFfi68Mz1D2WeUK8An6KKhAR0e6g-mwJraL3l8A",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-13T02:28:15.262391Z",
//   "user": {
//     "id": "TAcc3KT6ikeaqhvL",
//     "email": "michael+planeticeservice@sportninja.com",
//     "created_at": "2022-08-29T23:14:34+00:00",
//     "updated_at": "2025-12-06T02:28:07+00:00",
//     "validated_at": "2022-08-29T23:14:42+00:00"
//   }
// }
const planetIceToken =
  'v2.local.8sEn6tliWKBreIJ_TwNhoTu43fNGNSO1r04oR3HaDD3H7NWRMzWMIz9fLcobWk8gQVGE5KK-Fwz3wQd_e_NHgq-rabwepC5jGYV4YvXMvR80Lq8nsBOd0j7GwjChVOla6wmdwp-gVJ0t77oGJdtGEd8j-Mx7gHODVmnSBFOCPTs89aacnzBKuD5BAHMYLjmRdtz4PJJgyFqlzu7qaq_vmSFdH_vZRj81-vYaRInZVqrn5Bi0zx7xELVa9Nh-1dx6UMSyjh2rR36Wg6-MBYfXwXGhIxFSD4KgpWutq4tbct2gJ8u8YBCSxU9PtzdtFfi68Mz1D2WeUK8An6KKhAR0e6g-mwJraL3l8A'

// {
//   "access_token": "v2.local.L4bWhsZvw_9E75wabHAhJSE8rywkd_pS3XH6pwVgIK3AxVtsL0vu8kujBO8oDsFDe-tiX47os5jJwoH87soR9m7WYsDmvcwOXTOs-0UyN86ydUripK13FSCHOiRrBXXPwQsaaRK5STs4aiEqmB5IxRqLVFoHuVDCkWu7oruOmfilFDHj0mx5fNF7wf6nkpVJli20-PA7LM1CYa4VtE3Ub4cxi3hSmyMBqGhS8cGsxFoBfXwveHk0k4uAK9fhzfpCHGEZt6NZr7vOAXPFHZM15UGWG6mzYbLpuwFpBJlJK1ZEWDH1JrOi1U02BbOIseV0uwVfv8jkuZNZAglrP2ya9uj6yR8i",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-13T02:29:09.300806Z",
//   "user": {
//     "id": "oP37ysYCd57bFlkj",
//     "email": "michael+carhaservice@sportninja.com",
//     "created_at": "2022-05-27T18:35:59+00:00",
//     "updated_at": "2025-12-06T02:29:06+00:00",
//     "validated_at": "2022-05-27T18:35:59+00:00"
//   }
// }
const carhaToken =
  'v2.local.L4bWhsZvw_9E75wabHAhJSE8rywkd_pS3XH6pwVgIK3AxVtsL0vu8kujBO8oDsFDe-tiX47os5jJwoH87soR9m7WYsDmvcwOXTOs-0UyN86ydUripK13FSCHOiRrBXXPwQsaaRK5STs4aiEqmB5IxRqLVFoHuVDCkWu7oruOmfilFDHj0mx5fNF7wf6nkpVJli20-PA7LM1CYa4VtE3Ub4cxi3hSmyMBqGhS8cGsxFoBfXwveHk0k4uAK9fhzfpCHGEZt6NZr7vOAXPFHZM15UGWG6mzYbLpuwFpBJlJK1ZEWDH1JrOi1U02BbOIseV0uwVfv8jkuZNZAglrP2ya9uj6yR8i'

// {
//   "access_token": "v2.local.lqdykldC1mCLSK5KUgmd_XYjs1SIAvTg5wM3Ta0BVhz48jEU_aHW0Ya1vtRzrWkLHrC_Mg695DE91f5zwFD_iNgxeJHYwYT2dHBQGeKB8OpG84ea_5o9PdlFTRc14yx0OJQHWYmKN7Btq9i6NtA3BuLtFyuAljpx5HeEA8uRWyzyZ9YP5zWpnvxY6xf_EJf5wTaP6FR96_6uotubcjKD4o2YjhcWNTJxSHsRN90s_Gbt1RobKtKUu1QypK0dLZzQiy8TAjTDR7YVvPhhJCq6jsx3s_d6PiYAnIcLmEfpgn3iM-81Vfxin-jp6nyNwFBgjde0_WLQrjx7CM2rOTBAA-nsSIo",
//   "token_type": "Bearer",
//   "expires_in": 604800,
//   "expires_at": "2025-12-13T02:30:13.324477Z",
//   "user": {
//     "id": "jJkc8qSsffa24rAE",
//     "email": "michael+canlanservice@sportninja.com",
//     "created_at": "2022-05-30T20:39:26+00:00",
//     "updated_at": "2023-05-19T19:59:44+00:00",
//     "validated_at": "2022-05-30T20:39:26+00:00"
//   }
// }
const canlanToken =
  'v2.local.lqdykldC1mCLSK5KUgmd_XYjs1SIAvTg5wM3Ta0BVhz48jEU_aHW0Ya1vtRzrWkLHrC_Mg695DE91f5zwFD_iNgxeJHYwYT2dHBQGeKB8OpG84ea_5o9PdlFTRc14yx0OJQHWYmKN7Btq9i6NtA3BuLtFyuAljpx5HeEA8uRWyzyZ9YP5zWpnvxY6xf_EJf5wTaP6FR96_6uotubcjKD4o2YjhcWNTJxSHsRN90s_Gbt1RobKtKUu1QypK0dLZzQiy8TAjTDR7YVvPhhJCq6jsx3s_d6PiYAnIcLmEfpgn3iM-81Vfxin-jp6nyNwFBgjde0_WLQrjx7CM2rOTBAA-nsSIo'

export const getIframeToken = () => {
  const parentUrl =
    window.location !== window.parent.location
      ? window?.document?.referrer
      : window?.document?.location?.href

  let isPlanetIce = false
  if (parentUrl && parentUrl.includes('pacificadulthockey.com')) {
    isPlanetIce = true
  }
  return isCanlan ? canlanToken : isPlanetIce ? planetIceToken : carhaToken
}
